import { Box, Button, Chip, Dialog, Dropdown, IconButton, Menu, MenuItemProps, Metadata, useGraphqlDelete, useListGraphqlQuery, useTranslation, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { TUserStudentFamily } from "@bsm/graphql";
import { UserStudentItem } from "./UserStudentItem";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { FAMILY_LIST_ID } from "../../../container/UserStudentFamilyListContainer";

export const UserStudentFamilyDetails = (props: Partial<TUserStudentFamily>) => {

    const [
        METADATA,
        DESIGNATION,
        FATHER_NAME,
        MOTHER_NAME,
        PAYMENT_PERIOD,
        PREFERED_PAYMENT_CURRENCY,
        PAYMENT_TYPE,
        EMAILS,
        COMMENTS,
        MEMBERS,
        CURRENCY,
        EDIT,
        DELETE,
        DELETE_DIALOG_TITLE,
        DELETE_DIALOG_MESSAGE,
        REMOVE,
        CANCEL
    ] = useTranslations(i18n)
    const t = useTranslation()
    const urlParams = useUrlParamsValueToString()
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | undefined>(undefined);
    const deleteMutation = useGraphqlDelete('userStudentFamily')
    const { invalidateQuery } = useListGraphqlQuery(FAMILY_LIST_ID);
    const navigate = useNavigate()

    useEffect(() => {
        if (deleteMutation.isSuccess) {
            invalidateQuery()
            navigate(`..?${urlParams}`)
        }
    }, [deleteMutation])

    const [wantToDelete, setWantToDelete] = useState(false);

    const handleClick = (menu: MenuItemProps) => {
        if (menu.ke === "delete") {
            setWantToDelete(true)
        }
    }

    const paymentType = useMemo(() => {
        const type = ['BANK_TRANSFERT', 'CHEQUE', 'CASH']
        if(type.includes(props.paymentType)) {
            return props.paymentType
        }
        return null
    }, [props.paymentType])

    return (
        <div className="flex flex-col gap-4">

            <div className="flex justify-end">
                {
                    props.isEditable &&
                    <>
                        <Link to={`edit?${urlParams}`}>
                            <Button
                                className="btn-default"
                                startIcon="fa-solid fa-pen"
                                label={EDIT}
                            />
                        </Link>

                        {
                            props.isDeletable &&
                            <IconButton
                                icon={"fa-ellipsis"}
                                onClick={(e) => setAnchorEl(e.currentTarget)}
                            />
                        }

                        <Dropdown anchorEl={anchorEl} onClose={() => setAnchorEl(undefined)}>
                            <Menu
                                items={[
                                    {
                                        label: DELETE,
                                        ke: 'delete'
                                    }
                                ]}
                                onClick={handleClick}
                            />
                        </Dropdown>
                    </>
                }
            </div >

            <Box title={METADATA}>
                <div className="flex flex-col gap-2 mt-4">
                    <Metadata
                        label={DESIGNATION}
                        value={props.designation}
                    />

                    <Metadata
                        label={FATHER_NAME}
                        value={props.fatherName}
                    />

                    <Metadata
                        label={MOTHER_NAME}
                        value={props.motherName}
                    />

                    <Metadata
                        label={PAYMENT_PERIOD}
                        value={t(`Bsm.Invoice.User.Student.Family.PaymentPeriod.${props.paymentPeriod}.Label`)}
                    />

                    <Metadata
                        label={PAYMENT_TYPE}
                        value={(
                            paymentType ? props.paymentType.split(',').map((item, index) => t(`Bsm.Invoice.User.Student.Family.PaymentType.${item}.Label`)).join(', ') : ''
                        )}
                    />

                    <Metadata
                        label={COMMENTS}
                        value={props.comments}
                    />
                </div>
            </Box>

            <Box>
                <div className="flex flex-col gap-2 mt-4">
                    <Metadata
                        label={EMAILS}
                        value={(
                            <div className="flex gap-2 flex-wrap">
                                {props.emails?.map((item, index) => {

                                    const mail = item.to ? `${item.to} <${item.email}>` : item.email
                                    return (
                                        <a href={`mailto:${mail}`} key={index}>
                                            <Chip label={mail} />
                                        </a>
                                    )
                                })
                                }
                            </div>
                        )}
                    />

                    <Metadata
                        label={CURRENCY}
                        value={(
                            <div className="flex gap-2 flex-wrap">
                                {props.currencies?.map((item, index) => {
                                    return (
                                        <Chip key={index} label={t(item.translationKey as any)} />
                                    )
                                })
                                }
                            </div>
                        )}
                    />
                </div>
            </Box>

            <Box className="" title={MEMBERS}>
                <div className="flex flex-col gap-2 mt-4 flex-wrap">
                    {props.members?.filter(member => !member.student.isEnrolled)?.map((item, index) => {
                        return (
                            <UserStudentItem key={index} {...item} />
                        )
                    })
                    }
                </div>

            </Box>

            <Dialog
                open={wantToDelete}
                confirmation
                title={DELETE_DIALOG_TITLE}
                message={DELETE_DIALOG_MESSAGE}
                onClose={() => setWantToDelete(false)}
                onCancel={() => setWantToDelete(false)}
                onConfirm={() => deleteMutation.mutate({ ids: [props?.id] })}
                btnCancel={{ label: CANCEL }}
                btnOk={{
                    label: REMOVE,
                    className: "bg-danger",
                    isSubmit: deleteMutation.isLoading,
                }}
            />
        </div >
    )

}

const i18n = [
    'std_metadata',
    "Bsm.Invoice.User.Student.Family.Designation.Label",
    "Bsm.Invoice.User.Student.Family.FatherName.Label",
    "Bsm.Invoice.User.Student.Family.MotherName.Label",
    "Bsm.Invoice.User.Student.Family.PaymentPeriod.Label",
    "Bsm.Invoice.User.Student.Family.PreferedPaymentCurrency.Label",
    "Bsm.Invoice.User.Student.Family.PaymentType.Label",
    "Bsm.Invoice.User.Student.Family.Emails.Label",
    "Bsm.Invoice.User.Student.Family.Comments.Label",
    "Bsm.Invoice.User.Student.Family.Members.Label",
    "Bsm.Invoice.User.Student.Family.Currency.Label",
    'std_edit',
    'std_delete',
    "Bsm.Invoice.User.Student.Family.Delete.Dialog.Title",
    "Bsm.Invoice.User.Student.Family.Delete.Dialog.Message",
    "std_remove",
    "std_cancel",
]
